// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CausedByPopover {
  text-color: var(--bs-primary);
  border-color: var(--bs-primary);
  padding: 0.5rem 0.25rem;
}
.CausedByPopover h5 {
  padding: 0 0 0.5rem 0;
}
.CausedByPopover ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}`, "",{"version":3,"sources":["webpack://./src/features/IssueHistory/components/CausedByPopover/styles.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+BAAA;EACA,uBAAA;AACF;AAAE;EACE,qBAAA;AAEJ;AAAE;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AAEJ","sourcesContent":[".CausedByPopover {\n  text-color: var(--bs-primary);\n  border-color: var(--bs-primary);\n  padding: 0.5rem 0.25rem;\n  h5 {\n    padding: 0 0 0.5rem 0;\n  }\n  ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
